import React from 'react'
import NotFinishedPage from './NotFinishedPage'



export default function NotFinishedPageWrapper(props) {
    
    const innerContainerStyle = {
        width:'50%',
        position:'relative',
        backgroundColor:"white",
        border:"1px solid black",
        margin:"auto"
    }

    const outerContainerStyle = {
        width:'95.5%',
        height:'92%',
        position:'absolute',
        backgroundColor:"#ffffff80",
        zIndex:"1201",
    }


   
    return (
        <div style={outerContainerStyle}>
            <div style={innerContainerStyle}>
                <div className ={"rightTopBoxArea"}>
                    <div className = {"rightTopBox"} onClick={()=>props.closeModal()}>{"X"}</div>
                </div>
                <NotFinishedPage type={1}/>
            </div>
        </div>
    )
}